import styled from "styled-components"

const StyledContainer = styled.div`
    display: flex;
    flex-direction: column;
    min-width: 9rem;
    height: auto;
    align-items: center;
`

const StyledTitle = styled.div`
    font-family: 'Pretendard Variable';
    font-size: 0.75rem;
    color: black;
    font-weight: 400;
`

const StyledContentForNumber = styled.div`
    font-family: 'Vitro Inspire';
    font-size: 1.75rem;
    color: #A939FF;
    cursor: ${props => (props.onClick ? 'pointer' : 'default')};
`

const StyledContentForString = styled.div`
    font-family: 'Esamanru', sans-serif;
    font-weight: 700;
    font-size: 1.75rem;
    color: #000000;
    cursor: ${props => (props.onClick ? 'pointer' : 'default')};
`

export default function SquadMakerHeaderItem({isNumber, label, content, onClick}) {

    const contentProps = {
        onClick: onClick,
    };

    return(
        <StyledContainer>
            <StyledTitle>
                {label}
            </StyledTitle>

            <div style={{height: '1rem'}}/>

            {isNumber ? (
                <StyledContentForNumber {...contentProps}>
                    {content}
                </StyledContentForNumber>
            ) : (
                <StyledContentForString {...contentProps}>
                    {content}
                </StyledContentForString>
            )}
        </StyledContainer>
    )
}